import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../Components/Sidebar/Sidebar';
import ThemeSelector from '../Components/ThemeToggle/ThemeSelector';
import { fetchStatusChamado } from '../../api/statusChamado';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../config/backend';
import './preferenciasAtendimento.css';

function PreferenciasAtendimento() {
    const history = useHistory();
    const [statusList, setStatusList] = useState([]);
    const [statusEmAtendimento, setStatusEmAtendimento] = useState('');
    const [statusPausado, setStatusPausado] = useState('');
    const [statusEmDesenvolvimento, setStatusEmDesenvolvimento] = useState('');
    const [statusEmAnalise, setStatusEmAnalise] = useState('');
    const [statusEmTeste, setStatusEmTeste] = useState('');
    const [loadingConfig, setLoadingConfig] = useState(true);
    const [savingConfig, setSavingConfig] = useState(false);
    const [msgConfig, setMsgConfig] = useState('');

    const verificar = async () => {
        const resultado = await verificandoApp('ATENDENTE');
        if (!resultado) history.push('/');
    };

    const carregarPreferencias = async () => {
        setLoadingConfig(true);
        setMsgConfig('');
        const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2'));
        const token = localStorage.getItem('token');
        try {
            const [listaStatus, resConfig] = await Promise.all([
                fetchStatusChamado(false),
                baseUrl && token ? axios.get(baseUrl + '/usuarios/config-status', { headers: { Authorization: token } }).catch(() => ({ data: {} })) : Promise.resolve({ data: {} })
            ]);
            setStatusList(Array.isArray(listaStatus) ? listaStatus : []);
            const cfg = resConfig?.data || {};
            setStatusEmAtendimento(cfg.status_em_atendimento_codigo_legado != null ? String(cfg.status_em_atendimento_codigo_legado) : '10');
            setStatusPausado(cfg.status_pausado_codigo_legado != null ? String(cfg.status_pausado_codigo_legado) : '40');
            setStatusEmDesenvolvimento(cfg.status_em_desenvolvimento_codigo_legado != null ? String(cfg.status_em_desenvolvimento_codigo_legado) : '');
            setStatusEmAnalise(cfg.status_em_analise_codigo_legado != null ? String(cfg.status_em_analise_codigo_legado) : '');
            setStatusEmTeste(cfg.status_em_teste_codigo_legado != null ? String(cfg.status_em_teste_codigo_legado) : '');
        } catch (_) {
            setStatusList([]);
            setStatusEmAtendimento('10');
            setStatusPausado('40');
            setStatusEmDesenvolvimento('');
            setStatusEmAnalise('');
            setStatusEmTeste('');
        } finally {
            setLoadingConfig(false);
        }
    };

    const salvarPreferencias = async (e) => {
        e.preventDefault();
        setMsgConfig('');
        verificandoToken();
        const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2'));
        const token = localStorage.getItem('token');
        if (!baseUrl || !token) {
            setMsgConfig('Backend não configurado.');
            return;
        }
        setSavingConfig(true);
        try {
            await axios.put(baseUrl + '/usuarios/config-status', {
                status_em_atendimento_codigo_legado: statusEmAtendimento ? parseInt(statusEmAtendimento, 10) : null,
                status_pausado_codigo_legado: statusPausado ? parseInt(statusPausado, 10) : null,
                status_em_desenvolvimento_codigo_legado: statusEmDesenvolvimento ? parseInt(statusEmDesenvolvimento, 10) : null,
                status_em_analise_codigo_legado: statusEmAnalise ? parseInt(statusEmAnalise, 10) : null,
                status_em_teste_codigo_legado: statusEmTeste ? parseInt(statusEmTeste, 10) : null
            }, { headers: { Authorization: token } });
            setMsgConfig('Preferências salvas. Ao clicar Play o chamado irá para o status escolhido como "Em atendimento"; ao clicar Pause, para o status "Pausado".');
        } catch (err) {
            const msg = err?.response?.data?.message || err?.response?.data?.error || 'Não foi possível salvar. Tente novamente.';
            setMsgConfig(msg);
        } finally {
            setSavingConfig(false);
        }
    };

    useEffect(() => {
        verificar();
        carregarPreferencias();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo">
                    <div className="page-header preferencias-atendimento-header">
                        <h1><i className="fas fa-sliders-h" /> Preferências</h1>
                        <Link to="/alterarSenha" className="btn btn-outline-secondary btn-sm">
                            <i className="fas fa-user" /> Cadastro de usuário
                        </Link>
                    </div>

                    <section className="preferencias-section">
                        <header className="preferencias-section-header">
                            <h2 className="preferencias-section-title">
                                <i className="fas fa-palette" /> Aparência
                            </h2>
                            <p className="preferencias-section-desc">
                                Escolha como o Tacoma é exibido no seu dispositivo.
                            </p>
                        </header>
                        <ThemeSelector />
                    </section>

                    <section className="preferencias-section">
                        <header className="preferencias-section-header">
                            <h2 className="preferencias-section-title">
                                <i className="fas fa-play-circle" /> Play / Pause de chamados
                            </h2>
                            <p className="preferencias-section-desc">
                                Defina qual status o chamado assume ao clicar em Play (atendimento)
                                e em Pause (pausado) em cada contexto.
                            </p>
                        </header>
                    <p className="preferencias-atendimento-desc">
                        Defina qual status o chamado assume ao clicar <strong>Play</strong> em cada contexto e ao clicar <strong>Pause</strong> (pausado). Chamados com tipo <strong>usa sprint</strong> usam &quot;Em desenvolvimento&quot; na listagem e no board da sprint; na tela do chamado, a aba ativa (Atendimento, Análise ou Testes) define qual status será aplicado.
                    </p>
                    {loadingConfig ? (
                        <p className="text-muted">Carregando...</p>
                    ) : (
                        <form onSubmit={salvarPreferencias} className="preferencias-atendimento-form">
                            <div className="form-group">
                                <label htmlFor="pref-status-play">Status ao clicar Play (em atendimento)</label>
                                <select
                                    id="pref-status-play"
                                    value={statusEmAtendimento}
                                    onChange={(e) => setStatusEmAtendimento(e.target.value)}
                                    disabled={savingConfig}
                                    className="form-control"
                                >
                                    <option value="">— Selecione —</option>
                                    {statusList.map((s) => (
                                        <option key={s.id || s.codigo_legado} value={String(s.codigo_legado ?? s.id)}>{s.nome || s.codigo_legado}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="pref-status-pause">Status ao clicar Pause (pausado)</label>
                                <select
                                    id="pref-status-pause"
                                    value={statusPausado}
                                    onChange={(e) => setStatusPausado(e.target.value)}
                                    disabled={savingConfig}
                                    className="form-control"
                                >
                                    <option value="">— Selecione —</option>
                                    {statusList.map((s) => (
                                        <option key={s.id || s.codigo_legado} value={String(s.codigo_legado ?? s.id)}>{s.nome || s.codigo_legado}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="pref-status-desenvolvimento">Status ao clicar Play (em desenvolvimento)</label>
                                <select
                                    id="pref-status-desenvolvimento"
                                    value={statusEmDesenvolvimento}
                                    onChange={(e) => setStatusEmDesenvolvimento(e.target.value)}
                                    disabled={savingConfig}
                                    className="form-control"
                                >
                                    <option value="">— Selecione —</option>
                                    {statusList.map((s) => (
                                        <option key={s.id || s.codigo_legado} value={String(s.codigo_legado ?? s.id)}>{s.nome || s.codigo_legado}</option>
                                    ))}
                                </select>
                                <small className="text-muted">Usado na listagem e no board da sprint para chamados com tipo usa sprint.</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor="pref-status-analise">Status ao clicar Play (aba Análise)</label>
                                <select
                                    id="pref-status-analise"
                                    value={statusEmAnalise}
                                    onChange={(e) => setStatusEmAnalise(e.target.value)}
                                    disabled={savingConfig}
                                    className="form-control"
                                >
                                    <option value="">— Selecione —</option>
                                    {statusList.map((s) => (
                                        <option key={s.id || s.codigo_legado} value={String(s.codigo_legado ?? s.id)}>{s.nome || s.codigo_legado}</option>
                                    ))}
                                </select>
                                <small className="text-muted">Usado quando você está na aba Análise do chamado.</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor="pref-status-teste">Status ao clicar Play (aba Testes)</label>
                                <select
                                    id="pref-status-teste"
                                    value={statusEmTeste}
                                    onChange={(e) => setStatusEmTeste(e.target.value)}
                                    disabled={savingConfig}
                                    className="form-control"
                                >
                                    <option value="">— Selecione —</option>
                                    {statusList.map((s) => (
                                        <option key={s.id || s.codigo_legado} value={String(s.codigo_legado ?? s.id)}>{s.nome || s.codigo_legado}</option>
                                    ))}
                                </select>
                                <small className="text-muted">Usado quando você está na aba Testes do chamado.</small>
                            </div>
                            {msgConfig && (
                                <div className={`alert ${msgConfig.startsWith('Preferências salvas') ? 'alert-success' : 'alert-danger'}`} role="alert">
                                    {msgConfig}
                                </div>
                            )}
                            <button type="submit" className="btn btn-primary" disabled={savingConfig}>
                                {savingConfig ? 'Salvando...' : 'Salvar preferências'}
                            </button>
                        </form>
                    )}
                    </section>
                </div>
            </main>
        </div>
    );
}

export default PreferenciasAtendimento;
